export const CARDS_DB_KEY = 'cards-1.8'
